export default __webpack_public_path__ + "static/media/1.f095d924.png";